import React, { useState } from "react";
import CommonLayout from "../../../../Components/CommonLayout/CommonLayout";
import { TabView, TabPanel } from "primereact/tabview";
import UserPrivacy from "./Tab/UserPrivacy";
import CustomTextEditor from "../../../../custom/CustomTextEditor";
import CustomSelectDropdown from "../../../../custom/CustomSelectDropdown";
import CustomeToggleButton from "../../../../custom/CustomeToggleButton";
import { TbMailShare } from "react-icons/tb";

const EmailTemplate = ({meta}) => {
  const options1 = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
  ];

  const options2 = [
    { value: "option3", label: "Option 3" },
    { value: "option4", label: "Option 4" },
  ];

  const handleDropdown1Change = (selectedOption) => {
    // console.log("Dropdown 1 selected:", selectedOption);
  };

  return (
    <>
      <CommonLayout />
      <div className="w-[95%] mx-auto shadow-sm mt-5 border rounded-md p-5  bg-white">
        <div className="flex  items-center gap-3">
          <TbMailShare className="text-2xl" />
          <h1 className="text-xl">Sent E-mail from Gmail</h1>
        </div>
        <p className="mt-5">Select Email for</p>
        <div className="flex mt-2 justify-between">
          <div className="w-[30%]">
            <CustomSelectDropdown
              options={options1}
              placeholder="Select Option 1"
              onChange={handleDropdown1Change}
            />
          </div>

          <div className="flex gap-2 items-center">
            <CustomeToggleButton />
            <p>Do you want to send selected Email?</p>
          </div>
        </div>
        <div className="mt-5 w-full">
          <CustomTextEditor />{" "}
        </div>
      </div>
    </>
  );
};

export default EmailTemplate;
